module.exports = __webpack_public_path__ + "img/sphere04-graph-black.9d81dee1.png";